module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orbit-spinner",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "orbit one",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit two",
    style: (_vm.orbitStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "orbit three",
    style: (_vm.orbitStyle)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4122ca67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/OrbitSpinner.vue
// module id = 2162
// module chunks = 1